export type UserRole = 'dono' | 'admin' | 'default' | 'lojista' | 'comprador';
/** O perfil já traduzido pelo back: `default`, o das contas antigas, conta como lojista. */
export type Perfil = 'dono' | 'admin' | 'lojista' | 'comprador';

/** Ninguém mexe em quem é do seu nível ou acima; lojista e comprador estão no mesmo nível. */
export const NIVEL: Record<Perfil, number> = { dono: 3, admin: 2, lojista: 1, comprador: 1 };
export type OrigemCompra = 'SP' | 'PE' | 'REPRESENTANTE';

// `role`, `active` e `createdAt` ja vem em /auth/me (o backend devolve o documento do usuario,
// sem whitelist), mas login/cadastro nao garantem isso - por isso opcionais.
export type AuthUser = {
    _id: string;
    email: string;
    name: string;
    role?: UserRole;
    /** Só em /auth/me. */
    perfil?: Perfil;
    /** As origens que a conta compra (comprador e adm). Só em /auth/me. */
    origensCompra?: OrigemCompra[];
    active?: boolean;
    createdAt?: string;
};

export type UserResponse = {
    token: string;
    user: AuthUser;
};

// O cadastro NAO devolve token: a conta nasce inativa e so passa a valer depois que o dono
// do email clica no link de validacao. O backend responde { _id, active, email } - tratar
// isso como UserResponse fazia o front gravar um token `undefined` no storage.
export type RegisterResponse = {
    _id: string;
    active: boolean;
    email: string;
};